"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("../styles");
const colorManipulator_1 = require("../styles/colorManipulator");
const SvgIcon_1 = require("../SvgIcon");
exports.SIZES = ['sm', 'md'];
const styles = styles_1.createStyles(({ typography, palette, spacing, shape, shadows, transition }) => (Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ root: Object.assign(Object.assign({ 
        // resets
        verticalAlign: 'middle', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', border: 'none', padding: spacing(0.5, 1.5), outline: 'none', margin: 0, lineHeight: 1.75, cursor: 'pointer', transition: transition.create(['background-color', 'color', 'transform', 'box-shadow']), WebkitTapHighlightColor: 'transparent', WebkitAppearance: 'none', MozAppearance: 'none' }, typography.body), { fontWeight: typography.weights.semiBold, whiteSpace: 'nowrap', textDecoration: 'none', textTransform: 'uppercase', textAlign: 'center', 
        // specifics
        borderRadius: shape.borderRadius, [`& .${SvgIcon_1.svgIconClassName}`]: {
            '&:last-child': {
                marginLeft: spacing(0.75),
            },
            '&:first-child': {
                marginRight: spacing(0.75),
            },
            '&:only-child': {
                margin: 0,
            },
        }, color: palette.contrastText('surface'), '&:focus': {
            outline: `3px solid ${palette.light('primary')}`,
        }, '&:active': {
            outline: 'none',
        }, '&$disabled': {
            pointerEvents: 'none',
            backgroundColor: palette.darker('surface'),
            color: palette.darkest('surface'),
        } }) }, exports.SIZES.reduce((acc, size) => (Object.assign(Object.assign({}, acc), { [`size-${size}`]: {
        fontSize: size === 'md' ? '.875rem' : '.6rem',
    } })), {})), styles_1.COLORS.reduce((acc, color) => (Object.assign(Object.assign({}, acc), { [`contained-${color}`]: {
        backgroundColor: palette[color],
        color: palette.getContrastText(palette[color]),
        boxShadow: shadows[1],
        '&:hover': {
            backgroundColor: colorManipulator_1.darken(palette[color], 0.08),
        },
        '&:active': {
            boxShadow: shadows[3],
            backgroundColor: colorManipulator_1.darken(palette[color], 0.16),
        },
    } })), {})), styles_1.COLORS.reduce((acc, color) => (Object.assign(Object.assign({}, acc), { [`outlined-${color}`]: {
        color: palette[color],
        border: '1px solid currentColor',
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: colorManipulator_1.lighten(palette[color], 0.8),
        },
        '&:active': {
            backgroundColor: colorManipulator_1.lighten(palette[color], 0.6),
        },
    } })), {})), styles_1.COLORS.reduce((acc, color) => (Object.assign(Object.assign({}, acc), { [`text-${color}`]: {
        color: palette[color],
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: colorManipulator_1.lighten(palette[color], 0.8),
        },
        '&:active': {
            backgroundColor: colorManipulator_1.lighten(palette[color], 0.6),
        },
        '&$disabled': {
            backgroundColor: 'transparent',
        },
    } })), {})), { label: {
        width: '100%',
        display: 'inherit',
        alignItems: 'inherit',
        justifyContent: 'inherit',
    }, disabled: {} })));
exports.decorate = styles_1.withStyles(styles);
